<template>
    <WindowPopupNotification />
    <section :id="appId">
        <div class="d-lg-flex w-100" v-if="isLoggedIn && showAside">
            <div class="axxess-logo-vue cursor-pointer" @click="navigateToClinician">
                <img src="../../../img/axxess-logo.png" />
            </div>
            <div class="main-header-div">
                <div class="dashboard-header">
                    <DashboardHeader />
                </div>
                <div class="clinician-level-two position-relative">
                    <span class="ai-logo bg-white d-flex align-items-center m-2" v-if="showLogo && !isHelpPage">
                        <img src="../../../img/Axxess_Intelligence_Logo.svg" class="m-0 p-0" alt="" />
                        <button class="ai-premium-btn me-md-2">Premium</button>
                    </span>
                    <PlannerLevelTwo
                        v-if="!isAppLoading && hasFetchedAgencies"
                        :router="router"
                        :showIcons="true"
                        :grouped-agencies="groupedAgencies"
                        v-model:show-patients="showPatients"
                        v-model:show-employees="showEmployees"
                        v-model:open-agency-nav="openAgencyNav"
                    />
                </div>
            </div>
        </div>
        <div :class="`${isLoggedIn && showAside ? 'd-flex' : ''}`">
            <div id="aside">
                <aside
                    id="App__Aside"
                    v-if="isLoggedIn && showAside"
                    :class="openAgencyNav ? 'show-sidenav' : 'hide-sidenav'"
                >
                    <div :class="`w-100 action-list ${userOs == 'Windows' ? 'custom-scrollbar' : ''}`">
                        <AppNav :areRolesLoaded="areRolesLoaded" />
                        <AgencyList
                            :isLoading="isLoading"
                            :groupedAgencies="groupedAgencies"
                            :hasError="hasError"
                            v-on:loadAgencies="loadAgencies"
                        />
                    </div>
                </aside>
            </div>

            <header id="App__Header" v-if="isLoggedIn && !showAside">
                <CentralNav
                    :areRolesLoaded="areRolesLoaded"
                    v-model:showEmployees="showEmployees"
                    v-model:showPatients="showPatients"
                />
            </header>

            <main id="App__Main">
                <template v-if="startApp">
                    <router-view />

                    <template v-if="showPatients || showEmployees">
                        <Dialog
                            v-model:visible="showEmployees"
                            class="dashboard-dialog"
                            position="bottomright"
                            modal
                            :show-header="false"
                            :style="{ height: '100vh' }"
                        >
                            <div class="h-100">
                                <EmployeeList v-model:showEmployees="showEmployees" />
                            </div>
                        </Dialog>
                        <Dialog
                            v-model:visible="showPatients"
                            class="dashboard-dialog"
                            position="bottomright"
                            modal
                            :show-header="false"
                            :style="{ height: '100vh' }"
                        >
                            <div class="h-100">
                                <PatientList v-model:showPatients="showPatients" />
                            </div>
                        </Dialog>
                    </template>
                </template>
            </main>
        </div>
    </section>
    <LoadingIndicator :is-loading="isAppLoading"></LoadingIndicator>
    <DynamicDialog />
    <Notification v-if="isAnyPremiumAgency && hasAxxessConnectPermission" />
    <footer class="foot-class">
        Axxess © {{ new Date().getFullYear() }} |
        <span v-tooltip="{ title: ` Released on ${releaseTime}` }">Release Version: {{ releaseVer }}</span> |
        Environment: {{ releaseEnv }} | Built in Dallas, Texas
    </footer>
</template>

<script lang="ts" src="./App.ts"></script>
<style src="./App.scss"></style>
